import { render, staticRenderFns } from "./OutboxReviewInfo.vue?vue&type=template&id=00dae6e4&scoped=true"
import script from "./OutboxReviewInfo.vue?vue&type=script&lang=js"
export * from "./OutboxReviewInfo.vue?vue&type=script&lang=js"
import style0 from "./OutboxReviewInfo.vue?vue&type=style&index=0&id=00dae6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dae6e4",
  null
  
)

export default component.exports